export default ({
  SECTION                                           : 'overview',

  PLANS_OVERVIEW_IS_FIRST_LOADING                   : 'PLANS_OVERVIEW_IS_FIRST_LOADING',

  PLANS_OVERVIEW_GET_INFO_PLAN_FETCH_REQUEST        : 'PLANS_OVERVIEW_GET_INFO_PLAN_FETCH_REQUEST',
  PLANS_OVERVIEW_GET_INFO_PLAN_FETCH_SUCCESS        : 'PLANS_OVERVIEW_GET_INFO_PLAN_FETCH_SUCCESS',
  PLANS_OVERVIEW_GET_INFO_PLAN_FETCH_ERROR          : 'PLANS_OVERVIEW_GET_INFO_PLAN_FETCH_ERROR',
});